import { useEffect } from 'react';

const INTERCOM_APP_ID = 'il6idabg';

const Intercom = () => {
  useEffect(() => {
    window.intercomSettings = {
      api_base: 'https://api-iam.intercom.io',
      app_id: INTERCOM_APP_ID,
    };

    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      const i = function () { i.c(arguments); };
      i.q = [];
      i.c = function (args) { i.q.push(args); };
      w.Intercom = i;

      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
      document.head.appendChild(s);
    }

    return () => {
      if (typeof w.Intercom === 'function') {
        w.Intercom('shutdown');
      }
    };
  }, []);

  return null;
};

export default Intercom;
